module.exports = __webpack_public_path__ + "img/2023big36.b013321c.png";